import Action  from './baseActions';
import {
  Report,
} from '../../models';

export enum ReportFormActionTypes {
  LOAD_REPORT = 'report/load_report',
  LOADING_REPORT = 'report/loading_report',
  LOADED_REPORT = 'report/loaded_report',
  LOADING_REPORT_FAILED = 'report/loading_report_failed',
  UNSET_REPORT = 'report/unset_report',

  /*
   * UPDATE_REPORT triggers an API call
   */
  UPDATE_REPORT = 'report/update_report',
  UPDATING_REPORT = 'report/updating_report',
  UPDATED_REPORT = 'report/updated_report',
  UPDATING_REPORT_FAILED = 'report/updating_report_failed',

  ADD_BLOCK = 'report/add_block', // adds newly created block / content
  ADD_BLOCKS = 'report/add_blocks', // adds newly created blocks
  UPDATE_BLOCKS = 'report/update_blocks', // updates blocks wih `uid`
  UPDATE_BLOCKS_POSITION = 'report/update_position', // on drag and drop
  REMOVE_BLOCK = 'report/remove_block',

  SET_FOLDER = 'report/set_folder',
  SET_PROPERTY = 'report/set_property', // {key: value} property (used for `name`)
  SET_OPTIONS = 'report/set_options',

  SET_READ_ONLY = 'report/set_read_only',
}

// Interfaces

export interface LoadReportAction extends Action {
  type: ReportFormActionTypes.LOAD_REPORT;
  payload: string;
}

export interface LoadingReportAction extends Action {
  type: ReportFormActionTypes.LOADING_REPORT;
}

export interface LoadedReportAction extends Action {
  type: ReportFormActionTypes.LOADED_REPORT;
  payload: any;
}

export interface LoadingReportFailedAction extends Action {
  type: ReportFormActionTypes.LOADING_REPORT_FAILED;
}

export interface UnsetReportAction extends Action {
  type: ReportFormActionTypes.UNSET_REPORT;
}

export interface UpdateReportAction extends Action {
  type: ReportFormActionTypes.UPDATE_REPORT;
  payload: {
    uid: string;
    report: Partial<Report>;
  };
}

export interface UpdatingReportAction extends Action {
  type: ReportFormActionTypes.UPDATING_REPORT;
}

export interface UpdatedReportAction extends Action {
  type: ReportFormActionTypes.UPDATED_REPORT;
  payload: any;
}

export interface UpdatingReportFailedAction extends Action {
  type: ReportFormActionTypes.UPDATING_REPORT_FAILED;
}

export interface AddBlockAction extends Action {
  type: ReportFormActionTypes.ADD_BLOCK;
  payload: {
    block: any;
    addAfter?: string; // `uid`
  };
}

export interface AddBlocksAction extends Action {
  type: ReportFormActionTypes.ADD_BLOCKS;
  payload: {
    blocks: any[];
    addAfter?: string; // `uid`
  }
}

export interface UpdateBlocksAction extends Action {
  type: ReportFormActionTypes.UPDATE_BLOCKS;
  payload: {
    blocks: any[],
  }
}

export interface UpdateBlocksPositionAction extends Action {
  type: ReportFormActionTypes.UPDATE_BLOCKS_POSITION;
  payload: number[], // ids
}

export interface RemoveBlockAction extends Action {
  type: ReportFormActionTypes.REMOVE_BLOCK;
  payload: any;
}

export interface SetFolderAction extends Action {
  type: ReportFormActionTypes.SET_FOLDER;
  payload: any;
}

export interface SetPropertyAction extends Action {
  type: ReportFormActionTypes.SET_PROPERTY;
  payload: {
    key: string;
    value: any;
  };
}

export interface SetOptionsAction extends Action {
  type: ReportFormActionTypes.SET_OPTIONS;
  payload: {
    key: string;
    value: any;
  };
}

export interface SetReadOnlyAction extends Action {
  type: ReportFormActionTypes.SET_READ_ONLY;
  payload: boolean;
}

// Functions

export function loadReport(uid: string): LoadReportAction {
  return {
    type: ReportFormActionTypes.LOAD_REPORT,
    payload: uid,
  };
}

export function loadingReport(): LoadingReportAction {
  return {
    type: ReportFormActionTypes.LOADING_REPORT,
  };
}

export function loadedReport(report: any): LoadedReportAction {
  return {
    type: ReportFormActionTypes.LOADED_REPORT,
    payload: report,
  };
}

export function loadingReportFailed(): LoadingReportFailedAction {
  return {
    type: ReportFormActionTypes.LOADING_REPORT_FAILED,
  };
}

export function unsetReport(): UnsetReportAction {
  return {
    type: ReportFormActionTypes.UNSET_REPORT,
  };
}

export function updateReport(uid: string, report: Partial<Report>): UpdateReportAction {
  return {
    type: ReportFormActionTypes.UPDATE_REPORT,
    payload: {
      uid,
      report,
    },
  };
}

export function updatingReport(): UpdatingReportAction {
  return {
    type: ReportFormActionTypes.UPDATING_REPORT,
  };
}

export function updatedReport(report: any): UpdatedReportAction {
  return {
    type: ReportFormActionTypes.UPDATED_REPORT,
    payload: report,
  };
}

export function updatingReportFailed(): UpdatingReportFailedAction {
  return {
    type: ReportFormActionTypes.UPDATING_REPORT_FAILED,
  };
}

export function addBlock(block: any, addAfter?: string): AddBlockAction {
  /*
   * Add `block` (or `content`)
   */
  return {
    type: ReportFormActionTypes.ADD_BLOCK,
    payload: {
      block,
      addAfter,
    },
  };
}

export function addBlocks(blocks: any[], addAfter?: string): AddBlocksAction {
  /*
   * Add `block` (or `content`)
   */
  return {
    type: ReportFormActionTypes.ADD_BLOCKS,
    payload: {
      blocks,
      addAfter,
    },
  };
}

export function updateBlocks(blocks: any[]): UpdateBlocksAction {
  /*
   * Add `block` (or `content`)
   */
  return {
    type: ReportFormActionTypes.UPDATE_BLOCKS,
    payload: {
      blocks,
    },
  };
}

export function updateBlocksPosition(positions: number[]): UpdateBlocksPositionAction {
  /*
   * Add `block` (or `content`)
   */
  return {
    type: ReportFormActionTypes.UPDATE_BLOCKS_POSITION,
    payload: positions,
  };
}

export function removeBlock(uid: any): RemoveBlockAction {
  /*
   * Add `block` (or `content`)
   */
  return {
    type: ReportFormActionTypes.REMOVE_BLOCK,
    payload: uid,
  };
}

export function setFolder(folder: any): SetFolderAction {
  return {
    type: ReportFormActionTypes.SET_FOLDER,
    payload: folder,
  };
}

export function setProperty(key: string, value: any): SetPropertyAction {
  return {
    type: ReportFormActionTypes.SET_PROPERTY,
    payload: {
      key,
      value,
    },
  };
}

export function setOptions(key: string, value: any): SetOptionsAction {
  return {
    type: ReportFormActionTypes.SET_OPTIONS,
    payload: {
      key,
      value,
    },
  };
}

export function setReadOnly(readOnly: boolean): SetReadOnlyAction {
  return {
    type: ReportFormActionTypes.SET_READ_ONLY,
    payload: readOnly,
  }
}

// Types

export type ReportFormActions =
  | LoadReportAction
  | LoadingReportAction
  | LoadedReportAction
  | LoadingReportFailedAction
  | UnsetReportAction
  | UpdateReportAction
  | UpdatingReportAction
  | UpdatedReportAction
  | UpdatingReportFailedAction
  | AddBlockAction
  | AddBlocksAction
  | UpdateBlocksAction
  | UpdateBlocksPositionAction
  | RemoveBlockAction
  | SetFolderAction
  | SetPropertyAction
  | SetOptionsAction
  | SetReadOnlyAction;
